var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBadge2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.5,0 L71.9380207,0.00615596994 L71.4534686,0.0207410364 L70.9405183,0.0467701488 C66.3322038,0.324480413 61.9508636,1.77303504 58.1636184,4.20949766 L57.746,4.484 L57.3883555,4.24707339 C53.1273523,1.49096257 48.1551549,0 43,0 C28.3644541,0 16.5,11.8644541 16.5,26.5 L16.503698,26.9452493 C16.6145149,33.6136659 19.2103932,39.8098822 23.5426564,44.4942816 L23.661,44.62 L23.0861784,44.8065478 L21.823867,45.2328149 C18.4397188,46.4021918 15.1860194,47.7288363 12.0148378,49.2300232 C4.67812032,52.7031123 0,60.0934736 0,68.2107212 L0,73 L0.010924294,73.4451063 L0.0274159256,73.7050017 C0.389961515,78.364457 4.28338884,82 9,82 L14.556,82 L14.5820916,82.2183727 C15.1794927,86.6287695 18.9580781,90 23.5,90 L91.5,90 L91.9451063,89.9890757 L92.2050017,89.9725841 C96.4294307,89.6438873 99.8122156,86.4128463 100.407054,82.2973574 L100.444,82 L106.622566,81.9984975 L106.945106,81.9890757 C111.728561,81.7539572 115.5,77.8039558 115.5,73 L115.5,68.2107212 L115.495909,67.8069458 C115.322318,59.8069776 110.675493,52.633815 103.485166,49.2300248 L102.401963,48.7255105 C99.1424828,47.2320622 95.7942039,45.9194805 92.3586115,44.7881519 L91.839,44.62 L91.9579842,44.4940172 C96.3860708,39.7054091 99,33.3372464 99,26.5 C99,11.8644541 87.1355459,0 72.5,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.8%",
    y: "-6.1%",
    width: "111.3%",
    height: "114.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 2,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,5 C84.3741221,5 94,14.6258779 94,26.5 C94,35.0141414 89.0509819,42.3723776 81.8727342,45.8549204 C83.8520713,46.9560378 85.9893024,47.9092011 88.284618,48.7132923 L89.0555784,48.9757999 L89.7045255,49.1856693 C93.7108876,50.4508363 97.5917391,51.9721062 101.34584,53.7492377 C106.830248,56.3454722 110.364778,61.8147329 110.496204,67.861259 L110.5,68.2107212 L110.5,73 C110.5,75.1421954 108.816032,76.8910789 106.69964,76.9951047 L106.5,77 L9,77 C6.85780461,77 5.10892112,75.3160315 5.00489531,73.1996403 L5,73 L5,68.2107212 C5,62.0261516 8.56428235,56.3953998 14.1541617,53.749237 C17.1575563,52.3274778 20.242116,51.0694647 23.4251747,49.9694607 L24.6234726,49.5643547 L25.7954745,49.1856693 C28.6408776,48.287121 31.2512809,47.1756435 33.6283818,45.8546735 C26.4490181,42.3723776 21.5,35.0141414 21.5,26.5 C21.5,14.6258779 31.1258779,5 43,5 C48.338923,5 53.3448746,6.96343093 57.1946731,10.3493123 L57.5313399,10.6517442 L57.75,10.856 L57.9687456,10.6523132 C61.6480631,7.27570682 66.4463269,5.23144213 71.603901,5.01847753 L72.0884531,5.00389247 L72.5,5 Z",
    id: "Path",
    fill: "#00CCFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,9 C82.1649831,9 90,16.8350169 90,26.5 C90,36.1649831 82.1649831,44 72.5,44 C66.3031554,44 60.8585953,40.7790874 57.7491165,35.920059 C54.6414047,40.7790874 49.1968446,44 43,44 C33.3350169,44 25.5,36.1649831 25.5,26.5 C25.5,16.8350169 33.3350169,9 43,9 C49.1968446,9 54.6414047,12.2209126 57.7508835,17.079941 C60.8585953,12.2209126 66.3031554,9 72.5,9 Z M72.5,44 C76.6785714,47.8571429 81.7869898,50.7844388 87.8252551,52.7818878 L88.5,53 C92.3335906,54.2106076 96.0450504,55.6654769 99.6343792,57.364608 C103.826788,59.3492296 106.5,63.5722935 106.5,68.2107212 L106.5,73 L9,73 L9,68.2107212 C9,63.5722935 11.6732123,59.3492296 15.8656208,57.364608 C19.0960167,55.83539 22.4253387,54.5040241 25.8535867,53.3705101 L27,53 C33.1071429,51.0714286 38.2844388,48.2130102 42.5318878,44.4247449 L43,44 L72.5,44 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,17 C69.3741221,17 79,26.6258779 79,38.5 C79,47.0973362 73.953792,54.5160674 66.6616742,57.9558954 C69.1937392,59.4994876 71.8934261,60.7481052 74.7649111,61.7052668 C78.1701404,62.8403432 81.5751175,64.0284589 84.9798347,65.2696031 C91.1858347,67.5319132 95.3518637,73.3688991 95.4961301,79.9487604 L95.5,80.3019475 L95.5,81 C95.5,83.1421954 93.8160315,84.8910789 91.6996403,84.9951047 L91.5,85 L23.5,85 C21.3578046,85 19.6089211,83.3160315 19.5048953,81.1996403 L19.5,81 L19.5,80.3019475 C19.5,73.5785028 23.7033439,67.5723116 30.0201629,65.269604 C33.4248825,64.0284589 36.8298596,62.8403432 40.2350889,61.7052668 C43.1086984,60.747397 45.8100585,59.4977092 48.3404771,57.9564809 C41.0466696,54.516746 36,47.0977294 36,38.5 C36,26.6258779 45.6258779,17 57.5,17 Z",
    id: "Path",
    fill: "#00CCFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,81 L23.5,80.3019475 C23.5,75.2593646 26.652507,70.7547212 31.390123,69.0276899 C34.760082,67.7992163 38.130041,66.6233197 41.5,65.5 C47.5,63.5 52.8333333,60.3333333 57.5,56 L57.5,56 C62.1666667,60.3333333 67.5,63.5 73.5,65.5 C76.869959,66.6233197 80.239918,67.7992163 83.609877,69.0276899 C88.347493,70.7547212 91.5,75.2593646 91.5,80.3019475 L91.5,81 L23.5,81 Z M57.5,21 C67.1649831,21 75,28.8350169 75,38.5 C75,48.1649831 67.1649831,56 57.5,56 C47.8350169,56 40,48.1649831 40,38.5 C40,28.8350169 47.8350169,21 57.5,21 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBadge2);
export default __webpack_public_path__ + "static/media/login-badge-2.9d604a38e72ef094554fc9372670be6b.svg";
export { ForwardRef as ReactComponent };